import { IconButton } from 'component/Button'
import { Divider, Gap, Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { MaxPriceInput } from 'page/catalog/price/MaxPriceInput'
import { MinPriceInput } from 'page/catalog/price/MinPriceInput'
import { useDemo } from 'page/catalog/store/CatalogContext'
import { emdash } from 'util/typo'

export const PriceAccordion = observer(() => {
  const demo = useDemo()
  const { form } = demo
  const { min_price, max_price } = form
  const expand = form.price_expand
  const clear = min_price != null || max_price != null

  const onReset = useLatestCallback(() => {
    demo.form.min_price = null
    demo.form.max_price = null
  })

  const onExpand = useLatestCallback(() => {
    form.price_expand = !form.price_expand
  })

  return <Vertical>
    <Space gap={12} pad={[12, 8]} opposite wide>
      <Space gap={8}>
        <Typo size={11} medium upper>
          {i18n('Price')}
        </Typo>
        {!expand && <Space>
        </Space>}
      </Space>
      <Space gap={8} center>
        {clear && <IconButton size={32} action={onReset}>
          <Icon size={16} name="close" />
        </IconButton>}
        <IconButton size={24} action={onExpand}>
          <Icon size={16} name={expand ? 'keyboard_arrow_up' : 'keyboard_arrow_down'} />
        </IconButton>
      </Space>
    </Space>
    <Space>
      <Space flex="1" oh>
        <MinPriceInput />
      </Space>
      <Space width={24} center flex="0 0 auto">
        <Typo size={11} medium secondary>
          {emdash}
        </Typo>
      </Space>
      <Space flex="1" oh>
        <MaxPriceInput />
      </Space>
    </Space>
    <Gap height={16} />
    <Divider tertiary />
  </Vertical>
})
